import React from "react";
import { useTemplateSetting } from "../../../hooks/useCompanySettings";
import { TOOL_TEMPLATE } from "../../../constant/common";
import QuadrataAverageBasedCalculatorResults from "./templates/QuadrataAverageBasedCalculatorResults";
import VictorAverageBasedCalculatorResults from "./templates/VictorAverageBasedCalculatorResults";

const AverageBasedCalculatorResults = ({ results, formatNumber, currency }) => {
    const template = useTemplateSetting();

    switch (template) {
        case TOOL_TEMPLATE.quadrata:
            return (
                <QuadrataAverageBasedCalculatorResults
                    results={results}
                    formatNumber={formatNumber}
                    currency={currency}
                />
            );
        case TOOL_TEMPLATE.victor:
            return (
                <VictorAverageBasedCalculatorResults
                    results={results}
                    formatNumber={formatNumber}
                    currency={currency}
                />
            );
        default:
            return null;
    }
};

export default AverageBasedCalculatorResults;

